import type React from "react";
import type { VendorCompany } from "~/models/VendorCompany";
import { PATH as VENDOR_HOME_PATH } from "~/pages/vendors";
import { proxyLogin } from "~/utils/api/admin/VendorCompany";
import { isSuccess } from "~/utils/api/api_handler";
import Styles from "./Page.module.scss";

type Props = {
	vendorCompany: VendorCompany;
};

export const VendorCompanyRow: React.FC<Props> = ({ vendorCompany }: Props) => {
	const onClickProxyLogin = async (e: React.MouseEvent): Promise<void> => {
		e.preventDefault();
		const result = await proxyLogin(vendorCompany.id);
		if (isSuccess(result)) {
			window.location.assign(VENDOR_HOME_PATH);
		}
	};
	return (
		<tr className={Styles.CompanyRow}>
			<td>{vendorCompany.id}</td>
			<td>
				{vendorCompany.name}
				{vendorCompany.enabled ? null : "（取引終了）"}
			</td>
			<td>{vendorCompany.loginEmail}</td>
			<td>
				<a
					className={Styles.ProxyLoginLink}
					href="#"
					onClick={onClickProxyLogin}
				>
					代理ログイン
				</a>
			</td>
		</tr>
	);
};
